// extracted by mini-css-extract-plugin
export var deliveryRow = "_su-a";
export var fixedHeight = "_su-4";
export var freightLogo = "_su-9";
export var fullWidth = "_su-3";
export var priceColumn = "_su-5";
export var radioSelected = "_su-7";
export var radioUnselected = "_su-6";
export var selectedOption = "_su-2";
export var selectedOptionContainer = "_su-1";
export var selection = "_su-0";
export var tallSkeletonText = "_su-8";